

<div class="dashboard">  
    <div class="dashboard-img">
      <img [src]="valuesService.centralImages.illustrationIll404.link" [alt]="valuesService.centralImages.illustrationIll404.alt | translate" width="100%">
    </div>

    <div class="empty-state">
      <h4 id="h4_1654260773" class="title">{{'page.404.title' | translate}}</h4>
      <p id="p_1654260847" class="lead">{{'page.404.details' | translate}}</p>
      <button id="button_1654260870" ui-button model="solid" color="primary" (click)="goToDefault()">{{'page.404.button' | translate}}</button>
    </div>
</div>
